import type { ChatMessage } from "../chat/types";

export type Recipe = { tag: string; text: string; uses: string[] };

export const RECIPES: Recipe[] = [
  {
    tag: "when → then",
    text: '"DM me when anyone from OKX messages, no matter the chat."',
    uses: ["Telegram"],
  },
  {
    tag: "on schedule",
    text: '"Every morning at 7am, sort overnight chats into folders — clients, leads, vendors, noise."',
    uses: ["Telegram"],
  },
  {
    tag: "on schedule",
    text: '"Every Friday 5pm, summarize what I closed this week to my team chat."',
    uses: ["Telegram", "Notion"],
  },
  {
    tag: "pre-meeting",
    text: '"20 min before any Calendar invite with someone new, brief me on them via Apollo."',
    uses: ["Google Calendar", "Apollo"],
  },
  {
    tag: "when → then",
    text: '"If a deal goes 5 days without a reply, draft a follow-up in my voice and queue it."',
    uses: ["Telegram", "Gmail"],
  },
  {
    tag: "on event",
    text: '"When I RSVP yes on Luma, find who else from my deal list is going."',
    uses: ["Luma", "Telegram"],
  },
  {
    tag: "chained",
    text: '"After every call: notes to Notion, deal stage to HubSpot, action items to Linear."',
    uses: ["Google Calendar", "Notion", "HubSpot", "Linear"],
  },
];

export const BUILD_MESSAGES: ChatMessage[] = [
  {
    from: "user",
    text: "every monday at 8am, give me a list of the 5 deals i've been ignoring longest, and draft a one-line check-in for each",
  },
  {
    from: "bot",
    text: 'Got it. Building automation:\n\n• Trigger: Monday 8:00am\n• Source: deals you\'ve replied to in last 90d\n• Rank: longest silence first\n• Output: list + 5 drafts\n\nName it "Monday Revival"?',
  },
  { from: "bot", kind: "action", actions: ["Save & enable", "Tweak"] },
];
